import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/auralux.css';
import './styles/themes.css';
import './styles/pro-redesign.css';
import './styles/motion-layout.css';
import './styles/futuristic-hero.css';
import './styles/hero-masterbatch-bg.css';
import './styles/hero-copy-clouds.css';
import './styles/section-process-bg.css';
import './styles/brand-sections.css';
import './styles/case-studies.css';
import './styles/innovation-lab.css';
import './styles/sustainability-section.css';
import './styles/markets-section.css';
import './styles/ticker-rail.css';
import './styles/section-palettes.css';
import './styles/display-type.css';
import './styles/buttons-3d.css';
import './styles/nav-brand.css';
import './styles/why-section.css';
import './styles/hightech-sections.css';
import './styles/resource-teaser-v2.css';
import './styles/footer-hightech.css';
import './styles/contact-rainbow.css';
import './styles/color-mode.css';
import './styles/hero-split-layout.css';
import './styles/hero-image-slider.css';
import './styles/scroll-perf.css';
import App from './App';
import { DEFAULT_THEME_ID, STORAGE_KEY, THEME_BY_ID } from './theme/themes';
import { COLOR_MODE_STORAGE_KEY, DEFAULT_COLOR_MODE } from './context/ColorModeContext';
import { ensureApiConfig } from './lib/apiBase';

const bootTheme = (() => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && THEME_BY_ID[stored]) return stored;
  } catch {
    /* ignore */
  }
  return DEFAULT_THEME_ID;
})();
document.documentElement.setAttribute('data-theme', bootTheme);

const bootColorMode = (() => {
  try {
    const stored = localStorage.getItem(COLOR_MODE_STORAGE_KEY);
    if (stored === 'day' || stored === 'night') return stored;
  } catch {
    /* ignore */
  }
  return DEFAULT_COLOR_MODE;
})();
document.documentElement.setAttribute('data-color-mode', bootColorMode);

const root = ReactDOM.createRoot(document.getElementById('root'));
ensureApiConfig().then(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
